/*
 * @Author: zhu.huijun
 * @Date: 2021-05-11 09:56:09
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2021-08-06 14:30:55
 */
import { qryAvailableAccNbrList, qryAccNbrClass, operAccNbr } from '@/services/numberSelect';
import { getRequestData } from '@/utils/portalDscm';

const DefaultPageInfo = {
  currentPage: 1,
  pageSize: 30,
  total: 0,
};

export default {
  namespace: 'numberSelect',
  state: {
    numberList: [],
    pageInfo: DefaultPageInfo,
    accNbrClassList: [], // 号码等级
  },
  effects: {
    *qryAvailableAccNbrList({ payload }, { call, put }) {
      const data = yield call(qryAvailableAccNbrList, payload);
      const { accNbrDtoList, pageReqDto } = getRequestData(data) || {};
      yield put({
        type: 'save',
        payload: {
          numberList: accNbrDtoList || [],
          pageInfo: pageReqDto || DefaultPageInfo,
        },
      });
      return accNbrDtoList || [];
    },
    *qryAccNbrClass(_, { call, put }) {
      const data = yield call(qryAccNbrClass);
      const { accNbrClassDtoList } = getRequestData(data) || {};
      yield put({
        type: 'save',
        payload: {
          accNbrClassList: accNbrClassDtoList || [],
        },
      });
    },
    *operAccNbr({ payload }, { call }) {
      const data = yield call(operAccNbr, payload);
      const { returnCode } = getRequestData(data) || {};
      return returnCode === '0';
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
